export default "__VITE_ASSET__CsRJpBrP__"